(() => {
  const variantFor = form => document.getElementById(`product-form-${form.dataset.section}`)?.querySelector('[name="id"]')?.value || form.dataset.variant;
  const storageKey = form => `sofly-wishlist:v1:${form.dataset.customer || 'guest'}:${variantFor(form)}`;
  function remember(form, result) {
    if (form.dataset.purpose !== 'wishlist') return;
    try { localStorage.setItem(storageKey(form), JSON.stringify({active:result.active,kind:form.dataset.kind,expiresAt:Date.now()+30*24*60*60*1000})); } catch {}
  }
  function restore(form) {
    if (form.dataset.purpose !== 'wishlist') return;
    try {
      const saved=JSON.parse(localStorage.getItem(storageKey(form)) || 'null');
      if (!saved || saved.expiresAt <= Date.now() || saved.kind !== form.dataset.kind) return;
      form.querySelector('[data-sf-alert-status]').textContent=saved.active ? 'Wishlist saved in this browser.' : 'Wishlist saved. Check your email to confirm.';
      const toggle=form.closest('.sf-product-wishlist')?.querySelector('[data-sf-wishlist-open]');
      if(toggle){toggle.dataset.bladeState=saved.active ? 'saved' : 'pending';(toggle.querySelector('[data-sf-wishlist-label]') || toggle.lastChild).textContent=saved.active ? 'Added to wishlist' : 'Wishlist pending confirmation';}
    } catch {}
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-sf-alert]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      restore(form);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.enabled === 'false') return;
        const button = form.querySelector('button[type=submit]');
        const status = form.querySelector('[data-sf-alert-status]');
        button.disabled = true;
        status.textContent = 'Saving…';
        const base = `${window.Shopify?.routes?.root || '/'}apps/sofly-notifications`;
        try {
          const session = await fetch(`${base}/session`, {headers:{Accept:'application/json'}});
          if (!session.ok) throw new Error('Alerts are temporarily unavailable. Please try again later.');
          const {token} = await session.json();
          const variant = variantFor(form);
          const response = await fetch(`${base}/subscriptions`, {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({token,variant_id:variant,kind:form.dataset.kind,email:form.elements.email?.value,consent:form.elements.consent?.checked === true,terms:form.elements.terms?.checked === true,policy_version:form.elements.policy_version?.value,purpose:form.dataset.purpose || 'alert'})});
          const result = await response.json();
          if (!response.ok) throw new Error(response.status === 422 ? (Object.values(result.errors || {}).flat()[0] || result.message) : 'Unable to save your alert. Please try again later.');
          status.textContent = result.message;
          remember(form,result);
          const toggle = form.closest('.sf-product-wishlist')?.querySelector('[data-sf-wishlist-open]');
          if (toggle) { toggle.dataset.bladeState=result.active ? 'saved' : 'pending'; (toggle.querySelector('[data-sf-wishlist-label]') || toggle.lastChild).textContent = result.active ? 'Added to wishlist' : 'Wishlist pending confirmation'; toggle.setAttribute('aria-expanded','true'); }
        } catch (error) {
          status.textContent = error.message || 'Unable to save your alert. Please try again later.';
        } finally { button.disabled = false; }
      });
    });
    if (scope === document && new URLSearchParams(window.location.search).get('wishlist') === '1') {
      document.querySelector('[data-sf-wishlist-open]')?.click();
    }
  }
  document.addEventListener('click', e => {
    const close=e.target.closest('[data-sf-wishlist-close]');
    if(close){close.closest('dialog').close();return;}
    const button=e.target.closest('[data-sf-wishlist-open]');if(!button)return;
    const dialog=document.getElementById(button.getAttribute('aria-controls'));if(!dialog)return;
    const form=dialog.querySelector('form');restore(form);dialog.showModal();button.setAttribute('aria-expanded','true');
    dialog.addEventListener('close',()=>button.setAttribute('aria-expanded','false'),{once:true});
    (form.querySelector('input[type=email]') || form.elements.consent).focus();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
